<template>
  <div class="page-commercial-products">
    <tabbed-view :tabs="getTabs()"></tabbed-view>
  </div>
</template>

<script>

import TabbedView from '@/views/components/tabs/TabbedView';
import {mapGetters} from 'vuex';

export default {
name: "CommercialProduct",
  components: {
    TabbedView,
  },
  computed: {
    ...mapGetters({
      isDeleted: 'getIsDeleted'
    })
  },
  methods: {
    getTabs() {
      return [
        {
          label: 'Commercial Product Details',
          route: 'commercial-products.view',
        },
        {
          label: 'Assigned Producers',
          route: 'commercial-products.producers.view',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Alternative Commercial Products',
          route: 'commercial-products.alternative-commercial-products.view',
          hideIfDeleted: this.isDeleted,
        },
        {
          label: 'Extra Info',
          route: 'commercial-products.extra-info.view',
          hideIfDeleted: this.isDeleted,
        },
      ]
    }
  },
}
</script>

<style scoped>

</style>
